import mrRequest from '@/utils/request'

/* 获取整个角色列表 */
export function postRoleList() {
  return mrRequest.post({
    url: '/role/list'
  })
}

/* 获取整个部门列表 */
export function postDepartmentList() {
  return mrRequest.post({
    url: '/department/list'
  })
}

/* 获取整个菜单列表 */
export function postMenuList() {
  return mrRequest.post({
    url: '/menu/list'
  })
}
